<script>
import VideoPlayer from "./AppVideoPlayerwithObserver.vue";

import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    VideoPlayer,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["watchVideo"]),
  },
  methods: {
    ...mapActions(["toggleModal"]),
    showVideoLink() {
      if (
        typeof this.content.video !== "undefined" &&
        this.content.video.hasOwnProperty("vimeoId") &&
        this.content.video.vimeoId.length > 1
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<template>
  <article class="imageToSide vw-component">
    <div class="vw-grid">
      <div class="content">
        <h3 v-if="index > 0" class="heading-3 vw-component-title">
          {{ content.title }}
        </h3>
        <p class="vw-component-content body-copy-1">
          {{ content.copy }}
          <a
            v-if="showVideoLink()"
            @click.prevent="toggleModal(content.video)"
            href="#"
            class="learnMore"
            >{{ watchVideo }}</a
          >
        </p>

        <ProductIndicator
          v-if="
            typeof content.products !== 'undefined' &&
              content.products.length > 0
          "
          :active-products="content.products"
          class="vw-component-indicator"
        />
      </div>
      <VideoPlayer
        v-if="
          typeof content.video !== `undefined` &&
            content.video.hasOwnProperty('url')
        "
        :video="content.video"
        class="vw-component-video"
      />
      <AppResponsiveImage v-else :src="content.image" />
    </div>
  </article>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";
.content {
  text-align: center;
  grid-column: 1/1;
}
.vw-grid {
  display: flex;
  flex-direction: column;
}
img,
video {
  border-radius: 0;
}
@include mq($from: md) {
  .vw-grid {
    display: grid;
    flex-direction: column;
  }
  .vw-component-title {
    text-align: left;
  }

  .content {
    grid-column: 1 / span 5;
    padding-top: 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;

    p {
      text-align: left;
    }
  }
  .vw-component-indicator {
    margin-left: 0;
  }
  img,
  video {
    grid-column: 7 / span 6;
  }
  video {
    width: 100%;
    aspect-ratio: 1/1;
  }
  .iconGroup {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppImageToSide.vue